import axios from 'axios';
import { ICarePlanItem, ICarePlanCollectionPayload } from 'entities/CarePlan/CarePlan.models';

const basePath = 'care-plan';

export const carePlanTransport = {
  getCarePlanCollection: (payload: ICarePlanCollectionPayload): Promise<ICarePlanItem[]> =>
    axios.get(`${basePath}`, { params: payload }),
};
